import FileList from './FileList';
import FileUploadErrorModal from '../../utils/fileUploadErrorModal';
import UploadButtonGroup from './UploadButtonGroup';
import useDropboxUploadHandler from '../../hooks/useDropboxUploadHandler';
import { reportBtnClasses } from './listItemClasses';
import { reportSectionClasses } from './formClasses';

const CaseFileUpload = ({
  label,
  uploadButtonText = 'Upload File',
  onFileSelect,
  files = [],
  onRemove,
  disabled = false,
  isLoading = false,
  accept = 'application/pdf',
  multiple = false,
  inputName
}) => {
  const {
    handleDropboxSuccess,
    fileErrorList,
    setFileErrorList
  } = useDropboxUploadHandler({
    accept,
    onFilesReady: async (validFiles) => {
      onFileSelect?.({ file: validFiles, path: '' });
    }
  });

  return (
    <div className={reportSectionClasses}>
      <div className={`${reportBtnClasses} p-6 mb-0!`}>
        <span>{label}</span>
        <UploadButtonGroup
          uploadButtonText={uploadButtonText}
          uploadButtonProps={{ variant: 'link' }}
          accept={accept}
          multiple={multiple}
          disabled={disabled}
          isLoading={isLoading}
          inputName={inputName}
          onFileSelect={onFileSelect}
          onDropboxSuccess={handleDropboxSuccess}
        />
      </div>
      <FileList
        files={files}
        onRemove={(file) => onRemove?.(file)}
        isLoading={isLoading}
        disabled={disabled}
      />
      {fileErrorList.length > 0 && (
        <FileUploadErrorModal
          fileErrorList={fileErrorList}
          setFileErrorList={setFileErrorList}
        />
      )}
    </div>
  );
};

export default CaseFileUpload;
